import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './solicitacaoActions';
import Th from '../common/table/th';
import THead from '../common/table/tHead';
import Table from '../common/table/table';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Tr from '../common/table/tr';
import TBody from '../common/table/tBody';
import DateFormat from '../common/dateFormat/DateFormat';

class SolicitacaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {
		
		let readOnly = this.props.excluir || this.props.formularioValues.id_producao ? 'readOnly' : '';

		const parceiro = this.props.listaParceiro.filter(item => item.id == this.props.formularioValues.id_parceiro)[0];
		const mostraSilo = (parceiro && parceiro.solicita_silo) || this.props.formularioValues.silo;
		const mostraLote = (parceiro && parceiro.solicita_lote) || this.props.formularioValues.lote;

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>						
						<Row>
							<Field
								name='id_parceiro'
								options={this.props.listaParceiro}
								component={Select}
								label='Parceiro *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

							{!!this.props.formularioValues.id_tipo_producao &&
							<Field
								name='nome_tipo_producao'
								component={LabelAndInput}
								label='Tipo de Produção' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />}

							{!!this.props.formularioValues.id_fase_producao &&
							<Field
								name='nome_fase_producao'
								component={LabelAndInput}
								label='Fase de Produção' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'} />}
							
							<Field
								name='id_racao'
								options={this.props.listaRacao}
								component={Select}
								label='Ração *' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

							{mostraSilo &&
							<Field
								name='silo'
								component={LabelAndInput}
								label='Silo' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />}

							{mostraLote &&
							<Field
								name='lote'
								component={LabelAndInput}
								label='Lote' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />}
						</Row>
						{(this.props.formularioValues.contato_solicitado || this.props.formularioValues.whatsapp_solicitado || this.props.formularioValues.email_solicitado) &&
						<Row>
							<Field
								name='contato_solicitado'
								component={LabelAndInput}
								label='Contato do Solicitante' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								name='whatsapp_solicitado'
								component={LabelAndInput}
								label='Whatsapp do Solicitante' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								name='email_solicitado'
								component={LabelAndInput}
								label='E-mail do Solicitante' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />
						</Row>}
						<Row>
							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={180}
								readOnly={readOnly}
								title='Quantidade utilizada na fórmula'
								casas={2} />

							<Field
								name='id_unidade_medida'
								options={this.props.listaUnidadeMedida}
								component={Select}
								label='Unidade de Medida *' placeholder='Informe'
								cols='12 1 1 1'
								minWidth={300}
								readOnly={readOnly} />
						</Row>

						<Row>
							{!!this.props.formularioValues.datahora_solicitacao &&
							<LabelAndInput
								name='datahora_solicitacao'
								label='Solicitação' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'}
								value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_solicitacao)}
								onChange={() => {}} />}

							{!!this.props.formularioValues.datahora_confirmacao &&
							<LabelAndInput
								name='datahora_confirmacao'
								label='Confirmação' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={'readOnly'}
								value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_confirmacao)}
								onChange={() => {}} />}
							
							<LabelAndInputDate
								label='Previsão'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={this.props.formularioValues.data_previsao}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_previsao: value
									});
								}} />
						</Row>
						
						{/*
						<Row>
							<Grid cols='12 12 12 12'>
								<label>Entrega</label>
							</Grid>
						</Row>
						<Row>
							<Select
								name='id_veiculo'
								options={this.props.listaVeiculo}
								label='Veículo' placeholder='Informe'
								cols='12 4 3 3'
								readOnly={readOnly}
								value={this.props.formularioValues.entrega ? this.props.formularioValues.entrega.id_veiculo : null}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										entrega: {
											...(this.props.formularioValues.entrega || {}),
											id_veiculo: value
										}
									});
								}} />

							<Select
								name='id_motorista'
								options={this.props.listaMotorista}
								label='Motorista' placeholder='Informe'
								cols='12 4 4 4'
								readOnly={readOnly}
								value={this.props.formularioValues.entrega ? this.props.formularioValues.entrega.id_motorista : null}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										entrega: {
											...(this.props.formularioValues.entrega || {}),
											id_motorista: value
										}
									});
								}} />

							<LabelAndInputDate
								label='Agendamento'
								cols='12 1 1 1'
								readOnly={readOnly}
								value={this.props.formularioValues.entrega ? this.props.formularioValues.entrega.data_agendamento : null}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										entrega: {
											...(this.props.formularioValues.entrega || {}),
											data_agendamento: value
										}
									});
								}} />
						</Row>*/}
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }

}

SolicitacaoForm = reduxForm({form: 'solicitacaoForm', destroyOnUnmount: false})(SolicitacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('solicitacaoForm')(state),
	registro: state.solicitacao.registro,
	listaParceiro: state.parceiro.listaSelect,
	listaRacao: state.racao.listaSelect,
	listaUnidadeMedida: state.unidadeMedida.listaSelect,
	listaVeiculo: state.veiculo.listaSelect,
	listaMotorista: state.motorista.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SolicitacaoForm);
